import React from 'react';
import { Col, Row } from 'antd';
import { Colors, FontSize } from '@common/tokens';

function DataColumn({ label, value }: { label: string; value: string }) {
  return (
    <Col>
      <label className="text-heavy">{label}</label>
      <div>{value}</div>
    </Col>
  );
}

type Props = {
  organizationBusinessName: string;
  unitName: string;
  costCenter: string;
};

export const ApprovalsEditDrawerDataBox = ({
  organizationBusinessName,
  unitName,
  costCenter,
}: Props) => {
  return (
    <>
      <div className="approvals-page-drawer__data-box">
        <Row justify="space-between">
          <DataColumn label="Facility" value={organizationBusinessName} />
          <DataColumn label="Unit" value={unitName} />
          <DataColumn label="Cost Center" value={costCenter} />
        </Row>
      </div>
      <style jsx>{`
        .approvals-page-drawer__data-box {
          background: ${Colors.steelLightest};
          border: 1px solid ${Colors.steel};
          box-sizing: border-box;
          border-radius: 4px;
          padding: 16px;
          font-size: ${FontSize.md};
        }
        :global(.approvals-page-drawer__data-box .ant-row) {
          flex-wrap: nowrap;
        }
        :global(.approvals-page-drawer__data-box .ant-col:not(:last-child)) {
          margin-right: 16px;
        }
        :global(.approvals-page-drawer__data-box .ant-col:first-child) {
          min-width: 150px;
        }
        :global(.approvals-page-drawer__data-box .ant-col:last-child) {
          min-width: 100px;
        }
      `}</style>
    </>
  );
};
